<template>
  <v-form>
    <v-container>
      <v-layout>
        <div class="decretosBoton">
          <v-menu bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" small tile outline color="primary">
                <v-icon dark>keyboard_arrow_down</v-icon>&nbsp;Asistencia
              </v-btn>
            </template>
            <v-card class="px-2 py-1">
              <v-card-text class="black--text body-2">
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  <b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas"</b>...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días..."
                </span>
                <br />
                <v-icon small color="info">info</v-icon>&nbsp;
                <span>
                  Se deberán declarar los inmuebles urbanos y rurales que se encuentren en el país o en el extranjero que estén a nombre del declarante o a nombre de su cónyuge o conviviente cuando se trate de bienes comunes.
                </span>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto="<b>Artículo 33 de la Ley 004 Ley de Lucha contra la Corrupción, Enriquecimiento Ilícito e Investigación de Fortunas</b>...(Falsedad en la Declaración Jurada de Bienes y Rentas). El que falseare u omitiere insertar los datos económicos, financieros o patrimoniales, que la Declaración Jurada de Bienes y Rentas debá contener, incurrirá en privación de libertad de uno a cuatro años y multa de cincuenta a doscientos días.  "
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 md12 class="decretos">
          <alert-extendible
            texto="Se deberán declarar los inmuebles urbanos y rurales que se encuentren en el país o en el extranjero que estén a nombre del declarante o a nombre de su cónyuge o conviviente cuando se trate de bienes comunes."
          ></alert-extendible>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <v-btn color="success" dark @click.stop="dialog = true">
          <v-icon>add</v-icon>&nbsp;Adicionar
        </v-btn>
      </v-layout>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-dialog v-model="dialog" scrollable :max-width="deleteMode?600:1200" persistent>
          <v-card>
            <v-toolbar dark color="primary" right>
              <v-toolbar-title>
                <h4>Bienes Inmuebles Urbanos y Rurales</h4>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="cancel()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <div class="decretosBoton">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" small tile outline color="primary">
                          <v-icon dark>keyboard_arrow_down</v-icon>Asistencia
                        </v-btn>
                      </template>
                      <v-card class="px-2 py-1">
                        <v-card-text class="black--text body-2">
                          <v-icon small color="info">info</v-icon>&nbsp;
                          <span>
                            <b>Tipo de Adquisición:</b> Especificar si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar. 
                            <br />
                            <b>Descripción:</b> Detallar si el inmueble es: Casa, terreno, local, departamento, garaje, finca, galpón, depósito, nicho, etc., si es en copropiedad con terceros señalará el porcentaje de la alícuota parte que le corresponde.
                            <br />
                            <b>Ubicación:</b> Consignar, los datos precisos de ubicación, señalando el país  departamento, provincia, localidad y dirección exacta (Zona, barrio, avenida, calle, piso, departamento, U.V, Manzano. En propiedades rurales que no se tenga la dirección se debe detallar cualquier información referencial que identifique la propiedad. 
                            <br />
                            <b>Rentas Generadas en Bs.:</b> Si el bien genera rentas, debe detallar el importe en moneda nacional de dicha renta. 
                          </span>
                        </v-card-text>
                      </v-card>
                    </v-tooltip>
                  </div>
                  <v-flex xs12 md12 class="decretos">
                    <alert-extendible
                      texto="<b>Tipo de Adquisición:</b> Especificar si el bien es Propio o si es Común de acuerdo a los artículos 178 y siguientes del Código de las Familias y del Proceso Familiar. <br>
                      <b>Descripción:</b> Detallar si el inmueble es: Casa, terreno, local, departamento, garaje, finca, galpón, depósito, nicho, etc., si es en copropiedad con terceros señalará el porcentaje de la alícuota parte que le corresponde.<br>
                      <b>Ubicación:</b> Consignar, los datos precisos de ubicación, señalando el país  departamento, provincia, localidad y dirección exacta (Zona, barrio, avenida, calle, piso, departamento, U.V, Manzano. En propiedades rurales que no se tenga la dirección se debe detallar cualquier información referencial que identifique la propiedad.<br>
                      <b>Rentas Generadas en Bs.:</b> Si el bien genera rentas, debe detallar el importe en moneda nacional de dicha renta.       "
                    ></alert-extendible>
                  </v-flex>
                  <v-flex xs12>
                    <v-alert
                      :value="true"
                      type="warning"
                      v-show="deleteMode"
                      outline
                    >¿Está seguro de eliminar el bien inmueble siguiente?</v-alert>
                  </v-flex>
                </v-layout>
                <v-layout wrap align-center>
                  <v-flex xs12 sm12 md6>
                    <v-layout align-center>
                      <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'">
                        <template v-slot:contenido>
                          <span>
                            <b>Ayuda y Asistencia</b>
                          </span>
                          <br />
                          <v-divider color="primary" class="my-2" />
                          <span>NRO REGISTRO DE DD.RR. Ingresar el número de registro con el que se encuentra inscrito en Derechos Reales. En caso de no contar con el dato preciso se colocará cero y aclarará este aspecto en la casilla de “Observaciones”.</span>
                        </template>
                      </card-tool-tip>&nbsp;
                      <v-text-field
                        v-model="registroDdrr"
                        label="Nro. de Registro de DD.RR."
                        maxlength="40"
                        :disabled="deleteMode"
                      ></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm12 md6>
                    <v-select
                      :no-data-text="$t('comun.sin_datos')"
                      v-model="tipoAdquisicion"
                      :items="itemsTipoAdquisicion"
                      item-text="tipadq_descripcion"
                      item-value="tipadq_codigo"
                      label="Tipo de Adquisición*"
                      :rules="dRules"
                      required
                      :disabled="deleteMode"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="descripcion"
                          :rules="textRules"
                          v-on="on"
                          label="Descripción, Ubicación, País*"
                          required
                          maxlength="300"
                          :disabled="deleteMode"
                        ></v-text-field>
                      </template>
                      <span>
                        Detallar si el inmueble es: Casa, terreno, local, departamento, garaje, finca, galpón, depósito, nicho, etc., si es en copropiedad con terceros señalará el porcentaje de la alícuota parte que le corresponde.
                        <br />Ubicación: Consignar, los datos precisos de ubicación, señalando el país  departamento, provincia, localidad y dirección exacta (Zona, barrio, avenida, calle, piso, departamento, U.V, Manzano. En propiedades rurales que no se tenga la dirección se debe detallar cualquier información referencial que identifique la propiedad. 
                      </span>
                    </v-tooltip>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-text-field
                      v-model="anioAdquisicion"
                      :mask="mask_anio"
                      :rules="[ anioAdquisicionRules ]"
                      label="Año de Adquisición"
                      maxlength="4"
                      :disabled="deleteMode"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-layout align-center justify-end>
                      <card-tool-tip prepend-icon="help_outline" :icon-color="'primary'">
                        <template v-slot:contenido>
                          <span>
                            <b>Ayuda y Asistencia</b>
                          </span>
                          <br />
                          <v-divider color="primary" class="my-2" />
                          <span>RENTAS GENERADAS EN BS. Señalar el monto percibido por rentas generadas por el bien inmueble (alquiler) si corresponde. El valor debe ser expresado en moneda nacional (Bs). Para convertir monedas extrajeras a moneda nacional aplicará el tipo de cambio vigente a momento de la Declaración, según Tabla de Cotizaciones publicada por el Banco Central de Bolivia.</span>
                        </template>
                      </card-tool-tip>&nbsp;
                      <v-currency-field
                        v-model="rentasBien"
                        :rules='numbersRules'
                        label='Rentas Generadas en Bs.*'
                        required
                        :disabled="deleteMode"
                      ></v-currency-field>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 md6>
                    <v-currency-field
                      v-model="valorBien"
                      :rules='numbersRules'
                      label='Valor del bien en Bs.*'
                      required
                      :disabled='deleteMode'
                      >
                    </v-currency-field>
                  </v-flex>-->
                </v-layout>
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-tooltip color="secondary" top>
                      <template v-slot:activator="{ on }">
                        <v-textarea
                         @change="observaciones = $util.sanitiza(observaciones)"
                          v-model="observaciones"
                          label="Observaciones"
                          maxlength="250"
                          :counter="250"
                          v-on="on"
                          hint="Máximo 250 caracteres."
                          persistent-hint
                          :rules="$validate(['text_area'])"
                          :disabled="deleteMode"
                          rows="1"
                          auto-grow
                        ></v-textarea>
                      </template>
                      <span>
                        Detallar cualquier aclaración que el declarante considere pertinente, respecto a los datos de los “Bienes inmuebles Urbanos y Rurales”, en particular:
                        Aquello que implique incremento o decremento.
                        Si el bien inmueble (común) declarado se encuentra únicamente a nombre del cónyuge o conviviente.
                      </span>
                    </v-tooltip>
                  </v-flex>
                  <!--popup-->
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex sm12 md12>
                    <v-subheader>
                      <p class="plomo--text">Por favor llene los campos requeridos*</p>
                    </v-subheader>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="loadingButton" color="primary" @click="preVerificacion()">
                  <div v-if="deleteMode === true"><v-icon>delete</v-icon>&nbsp;Eliminar</div>
                  <div v-else><v-icon>save</v-icon>&nbsp;Guardar</div>
                </v-btn>
                <v-btn color="error" @click="cancel()"><v-icon>cancel</v-icon>&nbsp;Cancelar</v-btn>
              </v-card-actions>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-form>
      <v-layout wrap>
        <v-flex xs12 md12>
          <v-alert :value="true" :type="status_error" v-show="cod_error !== null">{{this.msg_error}}</v-alert>
        </v-flex>
        <v-flex xs12 md12>
          <v-alert
            class="tamanioBoton"
            v-show="!habilitarLista"
            :value="true"
            color="info"
            icon="info"
          >NO EXISTE NINGUNA INFORMACIÓN REGISTRADA</v-alert>
        </v-flex>
        <v-flex v-show="habilitarLista">
          <v-data-table
            :headers="headers"
            :items="datos"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props" class="justify-center layout px-0">
              <td>{{ props.item.nro }}</td>
              <td>
                <v-tooltip top color="blue">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="editItem(props.item)" v-on="on">
                      <v-icon color="blue">edit</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top color="red">
                  <template v-slot:activator="{ on }">
                    <v-btn icon class="mx-0" @click="deleteItem(props.item)" v-on="on">
                      <v-icon color="red">delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
              <td>{{ props.item.tipadq_descripcion }}</td>
              <td>{{ props.item.bie_fecha_adquisicion }}</td>
              <td>{{ props.item.bie_numero_registro }}</td>
              <!-- <td class="text-xs-right">{{ formatPrice(props.item.bie_precio_comercial) }}</td>-->
              <td>{{ formatPrice(props.item.bie_rentas_generadas) }}</td>
              <td>{{ props.item.bie_descripcion_ubicacion }}</td>
              <td><text-extendible :texto='props.item.bie_observacion'></text-extendible></td>
            </template>
            <template
              v-slot:pageText="props"
            >{{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}</template>
          </v-data-table>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-dialog v-model="repetidosModal" scrollable persistent max-width="350">
          <v-card>
            <v-card-title>
              <h4>
                <v-icon color="yellow">warning</v-icon>Advertencia
              </h4>
            </v-card-title>
            <v-card-text>Intenta agregar o actualizar información que se registró anteriormente, el registro o actualización es responsabilidad del declarante.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="tamanioBoton"
                color="primary"
                flat
                @click="repetidosModal = false, guardar()"
              ><v-icon>save</v-icon>&nbsp;Agregar de todos modos</v-btn>
              <v-btn
                class="tamanioBoton"
                color="error"
                flat
                @click="repetidosModal = false, cancel()"
              ><v-icon>cancel</v-icon>&nbsp;Descartar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>
  </v-form>
</template>
<script>
import validate from '@/common/mixins/validate';
import Parametricas from '../djbrd/mixins/parametricas';
import jsonQuery from 'json-query';
export default {
  mixins: [ Parametricas, validate ],
  created () {
    if (this.$storage.get('ex') === 1 && this.itemsTipoAdquisicion.length === 0) {
      this.obtenerTipoAdquisicionParametrica().then(respuesta => {
        this.itemsTipoAdquisicion = respuesta.datos;
      });
      this.obtenerBienes();
    }
  },
  data: () => ({
    loadingButton: false,
    codBien: 0,
    listaTipoBien: 1, // TiposBien 1 {1}

    headers: [
      { text: 'Nro', sortable: false, value: 'nro' },
      { text: 'Acciones', sortable: false, value: 'acciones' },
      {
        text: 'Tipo de Adquisición',
        sortable: false,
        value: 'tipoAdquisicion'
      },
      {
        text: 'Año de Adquisición',
        sortable: false,
        value: 'anioAdquisicion'
      },
      {
        text: 'Nro. de Registro de DD.RR.',
        sortable: false,
        value: 'nroRegistroDdrr'
      },
     // { text: 'Valor del bien en Bs.', sortable: false, value: 'valorBien' },
      {
        text: 'Rentas Generadas en Bs.',
        sortable: false,
        value: 'rentasBien'
      },
      { text: 'Descripción', sortable: false, value: 'descripcion' },
      { text: 'Observaciones', sortable: false, value: 'observaciones' }
    ],
    datos: [],
    registroDdrr: '',
    rowsPerPageItems: [5, 10, 25, {'text': 'Todo', 'value': -1}],
    tipoAdquisicion: null,
    itemsTipoAdquisicion: [],
    descripcion: '',
    anioAdquisicion: '',
    valorBien: 0,
    rentasBien: 0,
    observaciones: '',
    mask_anio: '####',
    nro: 1,
    dialog: false,
    menu1: false,
    menu2: false,
    editMode: false,
    deleteMode: false,
    cod_error: null,
    msg_error: null,
    status_error: null,
    anioAdquisicionStatic: 1970,
    dRules: [
      v => !!v || 'Este campo es requerido'
    ],
    textRules: [v => !!v || 'Este campo es requerido', v => /^[a-zA-Z0-9-_/.*()"“”,.;:=%#°ºñÑÁáÉéÍíóÓúÚäÄëËïÏöÖüÜ ]+$/.test(v) || 'Carácter especial no permitido'],
    numbersRules: [v => !!v || 'Este campo es requerido y debe ser un monto en Bolivianos',
      v => v.length < 11 || 'El valor solo puede tener máximo 8 números'],
    valid: true,
    habilitarLista: false,
    repetidosModal: false
  }),
  computed: {
  },
  methods: {
    anioAdquisicionRules (v) {
      if (!v) {
        return 'Este campo es requerido';
      }

      if (!!v && v <= this.anioAdquisicionStatic) {
        return `El año de aquisicíón debe ser mayor a ${this.anioAdquisicionStatic}`;
      }

      return true;
    },
    save () {
      let params = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        nro_registro_ddrr: this.registroDdrr,
        fecha_adquisicion: `${this.anioAdquisicion}-01-01`,
        ubicacion: this.descripcion,
        valor_bien_inmueble: this.valorBien,
        rentas_generadas: this.rentasBien,
        observacion: this.observaciones
      };
      this.$service
        .post(`djbr_registro/bienes_inmuebles`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.editMode = false;
              this.dialog = false;
              this.reinicializa();
              this.obtenerBienes();
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
      // }
    },
    update () {
      let params = {
        cod_bien: this.codBien,
        cod_tipo_adquisicion: this.tipoAdquisicion,
        nro_registro_ddrr: this.registroDdrr,
        fecha_adquisicion: `${this.anioAdquisicion}-01-01`,
        ubicacion: this.descripcion,
        valor_bien_inmueble: this.valorBien,
        rentas_generadas: this.rentasBien,
        observacion: this.observaciones
      };
      this.$service
        .put(`djbr_registro/bienes_inmuebles`, params)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.editMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          } else {
            this.loadingButton = false;
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    delete () {
      this.$service.delete(`djbr_registro/bienes/${this.codBien}`)
        .then(response => {
          if (response) {
            if (response.err_codigo === 0) {
              this.loadingButton = false;
              this.reinicializa();
              this.obtenerBienes();
              this.deleteMode = false;
              this.dialog = false;
              this.$message['success'](response.err_mensaje);
            } else {
              this.$message['warning'](response.err_mensaje);
              this.loadingButton = false;
            }
          }
        })
        .catch(e => {
          console.log(e);
          this.loadingButton = false;
        });
    },
    obtenerBienes () {
      this.$service
        .get(
          `djbr_registro/bienes/${this.listaTipoBien}`, {})
        .then(response => {
          if (response.length >= 1 && response[0].bie_codigo !== -1) {
            this.datos = response;
            this.nro = 0;
            for (let i = 0; i < this.datos.length; i++) {
              this.datos[i].bie_fecha_adquisicion = this.datos[i].bie_fecha_adquisicion.substring(0, 4) === '1970' ? '' : this.datos[i].bie_fecha_adquisicion.substring(0, 4);
              this.datos[i].nro = ++this.nro;
              this.habilitarLista = true;
            }
          } else {
            this.datos = [];
            this.habilitarLista = false;
          }
        });
    },
    editItem (item) {
      this.cargaData(item);
      this.editMode = true;
      this.dialog = true;
    },
    deleteItem (item) {
      this.cargaData(item);
      this.deleteMode = true;
      this.dialog = true;
      this.$refs.form.resetValidation();
    },
    cancel () {
      this.dialog = false;
      this.editMode = false;
      this.deleteMode = false;
      this.loadingButton = false;
      this.reinicializa();
    },
    preVerificacion () {
      if (this.deleteMode) {
        this.delete();
      } else {
        if (this.$refs.form.validate()) {
          this.loadingButton = true;
          var error = 0;
          if (!this.deleteMode) {
            if (this.anioAdquisicion !== '') {
              let AnioActualYear = new Date().getFullYear();
              if (parseInt(this.anioAdquisicion) > parseInt(AnioActualYear)) {
                this.$message['warning']('Por Favor revise el año de adquisición no es válido.');
                this.loadingButton = false;
                error = 1;
              } else if (parseInt(this.anioAdquisicion) <= 1970) {
                this.$message['warning']('Por Favor revise el año de adquisición no es válido.');
                this.loadingButton = false;
                error = 1;
              }
            } else {
              this.anioAdquisicion = '1970';
            }
            if (this.valorBien < 0) {
              this.$message['warning']('Por Favor revise el valor del bien no es válido.');
              this.loadingButton = false;
              error = 1;
            } else if (this.rentasBien < 0) {
              this.$message['warning']('Por Favor revise las rentas generadas no es válido.');
              this.loadingButton = false;
              error = 1;
            }
          }
          if (error === 0) {
            if (this.verificarRepetidos() && !this.deleteMode) {
              this.repetidosModal = true;
            } else {
              this.guardar();
            }
          }
        } else {
          this.$message['warning']('Por Favor revise los datos requeridos.');
        }
      }
    },
    guardar () {
      if (this.editMode) {
        this.update();
      } else {
        this.save();
      }
    },
    reinicializa () {
      this.codBien = 0; // id
      this.registroDdrr = '';
      this.tipoAdquisicion = null;
      this.descripcion = '';
      this.anioAdquisicion = '';
      this.valorBien = 0;
      this.rentasBien = 0;
      this.observaciones = '';
      this.$refs.form.resetValidation();
    },
    cargaData (item) {
      this.codBien = item.bie_codigo; // id
      this.registroDdrr = item.bie_numero_registro;
      this.tipoAdquisicion = item.tipadq_codigo;
      this.descripcion = item.bie_descripcion_ubicacion;
      this.anioAdquisicion = item.bie_fecha_adquisicion;
      this.valorBien = item.bie_precio_comercial.replace('.00', '');
      this.rentasBien = item.bie_rentas_generadas.replace('.00', '');
      this.observaciones = item.bie_observacion;
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2).replace(',', '.').replace('.00', '');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    verificarRepetidos () {
      let data = { lista: this.datos };
      let comparing = {
        cod_tipo_adquisicion: this.tipoAdquisicion,
        nro_registro_ddrr: this.registroDdrr,
        fecha_adquisicion: this.anioAdquisicion,
        ubicacion: this.descripcion.toUpperCase().trim(),
        rentas_generadas: typeof (this.rentasBien) === 'number' ? `${this.rentasBien}.00` : `${this.rentasBien}.00`,
        observacion: this.observaciones.toUpperCase().trim() || ''
      };
      let resultQuery = jsonQuery(`lista[*tipadq_codigo=${comparing.cod_tipo_adquisicion} & 
                                   bie_numero_registro=${comparing.nro_registro_ddrr} &
                                   bie_fecha_adquisicion=${comparing.fecha_adquisicion} &
                                   bie_descripcion_ubicacion=${comparing.ubicacion} &
                                   bie_rentas_generadas=${comparing.rentas_generadas} &
                                   bie_observacion=${comparing.observacion}]`, { data });
      if (this.editMode) {
        return resultQuery.value.length > 1;
      } else {
        return resultQuery.value.length > 0;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bienes/bienesInmuebles.vue